import { features } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            为什么选择哔咔动漫
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            五大核心优势，打造最纯粹的漫画追更体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center text-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-2xl mb-5 ${
                idx === 0 ? 'bg-primary-100 text-primary-600' :
                idx === 1 ? 'bg-accent-100 text-accent-600' :
                idx === 2 ? 'bg-secondary-100 text-secondary-600' :
                idx === 3 ? 'bg-primary-50 text-primary-500' :
                'bg-accent-50 text-accent-500'
              }`}>
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}